import * as $ from 'jquery';
import 'selectize';
import 'datepicker';
require('datatables.net');
require('datatablesResponsive');
import { memberPortal } from "./member-portal";
import { bookingFormCommon } from "./c005-bookingform-common";

export class flightStatusPage {
	private form:any = $('#flightstatus-searchform');
	private $scope:any = $('#flightstatus-searchresults');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): void {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.form.find('input[type="text"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): void {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.form.find('select'));

		_self.memberBase.initSelectizeInputs(inputSelectArr);
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): void {
		let _self = this;
		let inputDateArr = $('#flightstatus--depDate');
		let minDate:any = new Date();
		let maxDate:any = new Date((new Date().getFullYear() + 5).toString());

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
	}

	initTables(): void {
		let _self = this;
		let paging = false;
		let flightStatusTable = _self.$scope.find('.flightstatus-searchresults__table table');

		_self.memberBase.initTables(flightStatusTable, paging);
		_self.flightStatusTableFilter();
	}

	flightStatusTableFilter(): void {
		console.log('flight status filter code here');
	}
}


let scope:Element = document.querySelector('#flightstatus-searchform');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let flightstatuspage = new flightStatusPage();
		flightstatuspage.initTextInputs();
		$.when(window['ibeOnDList']).done((listData: any) => {
			console.log('%cc005fstatuspg%c ond done', 'background-color: yellow', 'background-color: initial');
			// onload use revenue OnD
			let listItems:string = bookingformcommon.parseOnDListItems(listData, 'revenue');
			let $flightStatusDestFrom: any = $('#flightstatus--destFrom');
			let $flightStatusDestTo: any =$('#flightstatus--destTo');
			$flightStatusDestFrom.html(listItems);
			$flightStatusDestTo.html(listItems);
			flightstatuspage.initSelectizeInputs();
		});
		flightstatuspage.initDatepickerInputs();
		flightstatuspage.initTables();
	} catch(e) {console.error(e);}
}
